import styled from 'styled-components'
import { Stack } from '@caudena/web-platform'

export const HighlightedLinkWrapper = styled.div`
  overflow: hidden;
`
export const HighlightedWrapper = styled(Stack)`
  overflow: hidden;
`
